import LoginLayout from '@src/routes/-layouts/login-layout';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({
  // Temporary redirect until the React app can handle mfa
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      href: `${import.meta.env.VITE_BASE_URL}/users/sign_in`,
    });
  },
  component: LoginLayout,
});
